<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-select v-model="formInline.cardType" placeholder="点卡类型" @change="getCardBatch">
                    <el-option label="低温奶卡" :value="4"></el-option>
                    <el-option label="常温奶卡" :value="5"></el-option>
                    <el-option label="牛奶专区" :value="1" disabled="true"></el-option>
                    <el-option label="咖啡卡" :value="2" disabled="true"></el-option>
                    <el-option label="低温点卡(即将作废)" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="formInline.cardBatchId" placeholder="卡批次" @change="cardBatchChange">
                    <el-option v-for="item in cardBatchList"
                               :key="item.batchId"
                               :label="item.batchName"
                               :value="item.batchId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称">
                <el-input v-model="formInline.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList()">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="showCopyCardItem">复制</el-button>
            </el-form-item>

            <el-form-item label="促销" v-show="formInline.cardType==4||formInline.cardType==5">
                <el-select filterable v-model="promotionItem.itemId" @change="onPromotionSelect"
                           remote
                           :remote-method="getPromotionList"
                           placeholder="输入促销名称查询"
                >
                    <el-option
                            v-for="item in promotionList"
                            :key="item.promotionId"
                            :label="item.promotionName"
                            :value="item.promotionId">
                    </el-option>
                </el-select>
                <el-button type="primary" v-show="formInline.cardType==4||formInline.cardType==5"
                           @click="handleAddPromotion">添加促销


                </el-button>
            </el-form-item>
        </el-form>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" style="height: 490"
                      v-loading="loading">
                <el-table-column type="index" label="序号" width="45"></el-table-column>
                <el-table-column prop="cardType" label="卡类型" width="90">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.cardType==1" type="success" effect="plain">牛奶专区</el-tag>
                        <el-tag size="mini" v-if="scope.row.cardType==2" type="warning" effect="plain">咖啡卡</el-tag>
                        <el-tag size="mini" v-if="scope.row.cardType==3" type="warning" effect="plain">低温点卡</el-tag>
                        <el-tag size="mini" v-if="scope.row.cardType==4" type="warning" effect="plain">低温奶卡</el-tag>
                        <el-tag size="mini" v-if="scope.row.cardType==5" type="warning" effect="plain">常温奶卡</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="productName" label="产品名称"></el-table-column>
                <el-table-column prop="itemType" label="产品类型" width="80">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.itemType==1" type="success" effect="plain">促销</el-tag>
                        <el-tag size="mini" v-if="scope.row.itemType==4" type="warning" effect="plain">单品</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="barCode" label="69码" width="120"></el-table-column>
                <el-table-column prop="unitPrice" label="销售价" width="80"></el-table-column>
                <el-table-column label="状态" width="130">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.status" :popper-append-to-body="true">
                            <el-option
                                    v-for="item in queryStatusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column :label=priceName width="170">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.saleValue"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column :label=priceOriName width="170">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.originPrice"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="success" size="mini" @click="saveCardItem(scope.row)">保存</el-button>
                            <el-button type="danger" v-show="scope.row.cardProductId!=null" size="mini"
                                       @click="deleteCardItem(scope.row)">删除
                            </el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="拷贝" :visible.sync="dialogFormVisible" center center top="5vh">
                <el-form :model="form" label-width="150px" size="small ">

                    <el-form-item label="原批次" :required="true">
                        <el-select v-model="sourceCardBatchId" clearable>
                            <el-option v-for="item in cardBatchList"
                                       :key="item.batchId"
                                       :label="item.batchName"
                                       :value="item.batchId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="目标批次" :required="true">
                        <el-select v-model="objCardBatchId" placeholder="目标批次">
                            <el-option v-for="item in cardBatchList"
                                       :key="item.batchId"
                                       :label="item.batchName"
                                       :value="item.batchId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <p style="color: #dd4b39">注意：复制以后将会完全覆盖目标批次的数据，请谨慎操作</p>
                        <p style="color: #dd4b39">若下拉列表无数据，请返回选择卡类型</p>

                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="copyCardItem()">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getCardItemList, copyCardItem,
        promotionList, getPromotionDetail,
        deleteCardItem,
        saveCardItem, getCardBatchOptionList
    } from '../../api/api';


    //定义组件
    export default {
        data() {
            return {
                sourceCardBatchId: null,
                objCardBatchId: null,
                dialogFormVisible: false,
                priceName: '销售点数',
                priceOriName: '原价点数',
                cardBatchList: [],
                dataList: [],
                promotionList: [],

                loading: true,
                formInline: {
                    cardType: "3",
                    name:null,
                    cardBatchId: null,
                    batchType: null
                },
                promotionItem: {
                    cardType: "3",
                    batchType: 0,
                    itemType: 1,
                    itemId: '',
                    unitPrice: 0,
                    saleValue: 0,
                    originPrice: 0,
                    status: 1,
                    cardBatchId: null
                },
                queryStatusList: [{value: 1, name: '有效'}, {value: 0, name: '无效'}, {value: -1, name: '下次不再显示'}],
                form: {
                    regularProductId: '',
                    productId: '',
                    productName: '',
                    channelType: '',

                },
            }
        },
        //挂载时候执行
        mounted() {
            this.getCardBatch();
            this.getList();
        },
        methods: {
            //定义查询方法
            getList() {
                if (this.formInline.cardType == "4" || this.formInline.cardType == "5") {
                    this.priceName = '销售价格';
                    this.priceOriName = '原价';
                } else {
                    this.priceName = '销售点数';
                    this.priceOriName = '原价点数';
                }
                if ((this.formInline.cardType == "4" || this.formInline.cardType == "5") && (this.formInline.cardBatchId == null || this.formInline.cardBatchId == '')) {
                    this.$message({
                        showClose: true,
                        message: "新奶卡配置请选择奶卡批次",
                        type: 'error'
                    });
                    return;
                }

                this.loading = true;
                getCardItemList({
                    "name":this.formInline.name,
                    "cardType": this.formInline.cardType,
                    "cardBatchId": this.formInline.cardBatchId
                }).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.dataList = [];
                        this.dataList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleAddPromotion(){
                if ((this.formInline.cardType == 4 || this.formInline.cardType == 5) && (this.formInline.cardBatchId == null || this.formInline.cardBatchId == '')) {
                    this.$message({
                        showClose: true,
                        message: "新奶卡配置请选择奶卡批次",
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                let promotion = this.promotionList.find(p => p.promotionId == this.promotionItem.itemId)
                getPromotionDetail({"promotionId": promotion.promotionId}).then((res) => {
                    this.loading = false;
                    this.promotionItem.unitPrice = res.data.value.promotionPrice;
                    let promotionItem = {
                        cardType: this.formInline.cardType,
                        batchType: this.formInline.batchType,
                        itemType: 1,
                        itemId: promotion.promotionId,
                        barCode: '-',
                        productName: promotion.promotionName,
                        unitPrice: res.data.value.promotionPrice,
                        saleValue: this.promotionItem.saleValue,
                        originPrice: this.promotionItem.originPrice,
                        status: 1,
                        cardBatchId: this.formInline.cardBatchId
                    }
                    this.dataList.unshift(promotionItem);
                })
            },
            onPromotionSelect(){
            },
            deleteCardItem(row){
                this.$confirm('删除产品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center: true,
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    deleteCardItem({
                        cardProductId: row.cardProductId
                    }).then((res) => {
                        this.loading = false
                        this.getList()
                    })
                })
            },
            getPromotionList(proName){
                this.loading = true;
                promotionList({
                    promotionName: proName,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0
                }).then((res) => {
                    this.loading = false;
                    //this.formInline.recordsTotal = res.data.total;
                    this.promotionList = res.data.list;
                })
            },
            saveCardItem(row) {
                //const loading = this.$loading(this.GCONFIG.loadingParam);
                this.loading = true
                saveCardItem(row).then((res) => {
                    //loading.close();
                    this.loading = false
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            getCardBatch(){
                var cardType = this.formInline.cardType;
                this.formInline.cardBatchId = null;
                if (cardType == "4" || cardType == "5") {
                    getCardBatchOptionList({"cardType": cardType}).then((res) => {
                        this.loading = false;
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '查询成功',
                                type: 'success'
                            });
                            this.cardBatchList = res.data.value;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                    this.getPromotionList('');
                } else {
                    this.formInline.cardBatchId = null;
                }
            },
            copyCardItem(){
                this.$confirm('复制以后将会完全覆盖目标批次的数据，请谨慎操作，确定继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (this.sourceCardBatchId == null) {
                        this.$message({
                            showClose: true,
                            message: "请选择原批次",
                            type: 'error'
                        });
                        return;
                    }
                    if (this.objCardBatchId == null) {
                        this.$message({
                            showClose: true,
                            message: "请选择目标批次",
                            type: 'error'
                        });
                        return;
                    }
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    copyCardItem({
                        "sourceCardBatchId": this.sourceCardBatchId,
                        "objCardBatchId": this.objCardBatchId
                    }).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            //this.getList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            showCopyCardItem(){
                this.dialogFormVisible = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/prepay/CardItem.vue